/** Product navigation never accepts script, data, relative or protocol-relative URLs. */
export const safeProductUrl = (value: unknown): string => {
  if (typeof value !== 'string') return '';
  const url = value.trim();
  if (!/^https?:\/\//i.test(url)) return '';
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
      ? url
      : '';
  } catch {
    return '';
  }
};
